import { render, staticRenderFns } from "./create-new-course.html?vue&type=template&id=662ba8c2&scoped=true&"
import script from "./create-new-course.js?vue&type=script&lang=js&"
export * from "./create-new-course.js?vue&type=script&lang=js&"
import style0 from "./create-new-course.scss?vue&type=style&index=0&id=662ba8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662ba8c2",
  null
  
)

export default component.exports